module.exports = __webpack_public_path__ + "static/media/nat-3-large.a10d3ac0.jpg";